function dfs(node, term, foundIDS) {
  // Implement your search functionality
  let isMatching = node.name && node.name.toLowerCase().indexOf(term.toLowerCase()) > -1;

  if (Array.isArray(node.children)) {
    node.children.forEach(child => {
      const hasMatchingChild = dfs(child, term, foundIDS);
      isMatching = isMatching || hasMatchingChild;
    });
  }

  // We will add any item if it matches our search term or if it has a children that matches our term
  if (isMatching && node.id) {
    foundIDS.push(node.id);
  }

  return isMatching;
}

function filter(data, matchedIDS) {
  return data
    .filter(item => matchedIDS.indexOf(item.id) > -1)
    .map(item => ({
      ...item,
      children: item.children ? filter(item.children, matchedIDS) : []
    }));
}

function search(data, term) {
  // We wrap data in an object to match the node shape
  const dataNode = {
    children: data
  };

  const matchedIDS = [];
  // find all items IDs that matches our search (or their children does)
  dfs(dataNode, term, matchedIDS);

  // filter the original data so that only matching items (and their fathers if they have) are returned
  return filter(data, matchedIDS);
}

export default search;
